import React from "react";
import clsx from "clsx";

import { Button, CircularProgress } from "@material-ui/core";
import { makeStyles, alpha } from "@material-ui/core/styles";

// Rodapé padrão das modais do sistema:
//   confirmar/OK  → azul preenchido (primary)
//   cancelar/voltar/fechar → branco com texto e borda vermelhos
//
// Antes cada modal tinha o seu jeito: cinza preenchido, rosa preenchido, rosa
// com contorno, texto vermelho, texto azul... Aqui é um lugar só, então mudar o
// padrão no futuro é mexer neste arquivo.
//
// Os dois aceitam as mesmas props de um Button do MUI (onClick, disabled, type,
// startIcon...). BotaoConfirmar aceita também `loading`, que desabilita e mostra
// o spinner por cima — substitui o ButtonWithSpinner nos rodapés.
const useStyles = makeStyles((theme) => ({
	cancelar: {
		color: theme.palette.error.main,
		borderColor: alpha(theme.palette.error.main, 0.5),
		"&:hover": {
			borderColor: theme.palette.error.main,
			backgroundColor: alpha(theme.palette.error.main, 0.06),
		},
	},

	confirmar: {
		position: "relative",
	},

	progresso: {
		color: theme.palette.primary.contrastText,
		position: "absolute",
		top: "50%",
		left: "50%",
		marginTop: -12,
		marginLeft: -12,
	},
}));

export const BotaoCancelar = ({ children, className, ...rest }) => {
	const classes = useStyles();

	return (
		<Button
			variant="outlined"
			className={clsx(classes.cancelar, className)}
			{...rest}
		>
			{children}
		</Button>
	);
};

export const BotaoConfirmar = ({ children, loading, disabled, className, ...rest }) => {
	const classes = useStyles();

	return (
		<Button
			variant="contained"
			color="primary"
			disabled={disabled || loading}
			className={clsx(classes.confirmar, className)}
			{...rest}
		>
			{children}
			{loading && <CircularProgress size={24} className={classes.progresso} />}
		</Button>
	);
};

export default BotaoConfirmar;
